/* Animates <details> open/close. Without JS the accordion still works natively. */
(() => {
  const init = (root) => {
    if (root.hasAttribute('data-faq-enhanced')) return;
    root.setAttribute('data-faq-enhanced', '');
    const speed = Number(root.dataset.faqSpeed ?? 350);

    root.querySelectorAll('.fq-item').forEach((item) => {
      const summary = item.querySelector('.fq-q');
      const panel = item.querySelector('.fq-a');
      if (!summary || !panel) return;

      let timer = 0;

      summary.addEventListener('click', (event) => {
        event.preventDefault();
        clearTimeout(timer);

        if (!item.open) {
          item.open = true;
          void panel.offsetHeight; // flush 0fr before the class flips it to 1fr
          item.setAttribute('data-open', '');
          return;
        }

        item.removeAttribute('data-open');
        if (!speed || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          item.open = false;
          return;
        }
        const close = () => {
          item.open = false;
        };
        panel.addEventListener('transitionend', close, { once: true });
        timer = setTimeout(close, speed + 50); // fail-safe if transitionend never fires
      });
    });
  };

  document.querySelectorAll('[data-flavor-faq]').forEach(init);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-flavor-faq]').forEach(init);
  });
})();
